import React, { Component } from "react";
import _ from "lodash";
import {
  Bar,
} from "react-chartjs-2";
import { formatNumber } from "../lib/utils.js";

export default class Chart extends Component {
  render() {
    return (
      <div className="result-charts">
        {this.props.results.map(({data,country}, index) => (
          <div key={index} className="chart">
            <div className="country">{country}</div>
            <Bar
              data={data}
              options={{
                mantainAspectRatio: false,
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                    }
                  }]
                }
              }}
            />
            {/*<ResponsiveContainer height={500} width="100%" minWidth={300}>
              <BarChart
                height={500}
                data={data}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="label" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="male" fill="#f5d862" />
                <Bar dataKey="female" fill="#86c87f" />
              </BarChart>
            </ResponsiveContainer>*/}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Chart.js